export default {
  navHome: "Trang chủ",
  navProducts: "Sản phẩm",
  navCases: "Ứng dụng thực tế",
  navAbout: "Về chúng tôi",
  deliverTo: "Giao hàng đến:",
  langCurrencyLabel: "Tiếng Việt",
  localeLangTitle: "Cài đặt ngôn ngữ",
  localeLangDesc: "Chọn ngôn ngữ ưa thích của bạn. Bạn có thể cập nhật cài đặt này bất cứ lúc nào.",
  language: "Ngôn ngữ",
  save: "Lưu",
  coreProducts: "Trao quyền sáng tạo trong thế giới thực.",
  coreProductsDesc: "Từ ý tưởng đến kinh doanh — YONGYUAN cung cấp máy in UV, máy in nhãn pha lê, máy in hình trụ tốc độ cao, máy in DTF và DTG, biến sáng tạo thành sản phẩm, thương hiệu và cơ hội.",
  scenariosTitle: "Giải pháp cho mọi kịch bản",
  scenariosDesc: "Dù bạn đang xây dựng thương hiệu, phát triển kinh doanh phụ hay theo đuổi đam mê sáng tạo, YONGYUAN đều có giải pháp phù hợp với nhu cầu của bạn.",
  scenarioStudio: "Studio",
  scenarioStudioDesc: "Tùy chỉnh giá trị cao, nguyên mẫu số lượng nhỏ và xây dựng thương hiệu",
  scenarioRetail: "Bán lẻ thương hiệu",
  scenarioRetailDesc: "Tăng thời gian lưu trú khách hàng và doanh thu cửa hàng",
  scenarioMarket: "Chợ lưu động",
  scenarioMarketDesc: "Tùy chỉnh tại chỗ, bán sản phẩm hoàn thiện và thu nhập phụ",
  scenarioEnterprise: "Tùy chỉnh doanh nghiệp",
  scenarioEnterpriseDesc: "Tùy chỉnh hàng loạt, hàng hóa thương hiệu và quà tặng doanh nghiệp",
  scenarioEcommerce: "Bán hàng livestream",
  scenarioEcommerceDesc: "Mẫu sản phẩm bán chạy, cung ứng linh hoạt và ra mắt sản phẩm nhanh",
  scenarioStore: "Cửa hàng thương mại điện tử",
  scenarioStoreDesc: "Tùy chỉnh cửa hàng, hàng hóa bán chạy và vận hành khác biệt",
  scenarioFactory: "Sản xuất nhà máy",
  scenarioFactoryDesc: "Sản xuất hàng loạt, đầu ra ổn định và vận hành hiệu quả chi phí",
  scenarioAdvertising: "Sản xuất quảng cáo",
  scenarioAdvertisingDesc: "Biển hiệu, vật liệu trưng bày và vật liệu sự kiện",
  industries: "Ứng dụng ngành",
  industriesDesc: "Giải pháp in phun kỹ thuật số cho in màu trong nhiều ngành.",
  applicationsTitle: "Mở khóa ứng dụng vật liệu và màu sắc đa dạng cho nhu cầu hàng ngày và thương mại.",
  applicationsDesc: "Thiết bị in UV YONGYUAN được thiết kế cho nhiều loại vật liệu và kịch bản quy trình, hỗ trợ cả tùy chỉnh cá nhân và sản xuất quy mô lớn.",
  casesHeroDesc: "Bao phủ hơn 1200 ứng dụng ngành và hàng chục nghìn loại vật liệu in, cung cấp giải pháp in kỹ thuật số cho các mô hình kinh doanh khác nhau.",
  casesBreadcrumbHome: "Trang chủ",
  casesBreadcrumbCenter: "Ứng dụng thực tế",
  casesEmpty: "Chưa có ứng dụng thực tế trong danh mục này.",
  customerStoriesTitle: "Được khách hàng trên toàn thế giới tin tưởng",
  customerStoriesSubtitle: "Lắp đặt thực tế, khách hàng thực tế, doanh nghiệp in ấn thực tế tại 172 quốc gia.",
  customerStoriesStat1Value: "53.000+",
  customerStoriesStat1Label: "Máy in đã giao",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "Quốc gia phục vụ",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "Năm kinh nghiệm",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "Hỗ trợ kỹ thuật",
  customerStoriesPlaceholder: "Thêm ảnh khách hàng",
  customerStoriesPhotoAlt: "Khách hàng YONGYUAN với máy in",
  servicePartnerTitle: "Gặp gỡ đội ngũ dịch vụ YONGYUAN, đối tác sáng tạo của bạn",
  servicePartnerDesc: "Mạng lưới dịch vụ toàn cầu và hệ thống hỗ trợ chuyên nghiệp bảo vệ hiệu suất thiết bị và tăng trưởng kinh doanh của bạn.",
  serviceSupportTitle: "Hỗ trợ tiêu chuẩn",
  serviceSupportDesc: "Hướng dẫn lắp đặt, đào tạo cơ bản và hỗ trợ sử dụng hàng ngày để thiết bị vận hành ổn định.",
  servicePresaleTitle: "Demo và tư vấn trước bán hàng",
  servicePresaleDesc: "Trình diễn giải pháp và đề xuất mẫu phù hợp với kịch bản ứng dụng và yêu cầu công suất của bạn.",
  serviceLifetimeTitle: "Hỗ trợ kỹ thuật trọn đời",
  serviceLifetimeDesc: "Phản hồi kỹ thuật liên tục và hỗ trợ quy trình đồng hành phát triển kinh doanh dài hạn của bạn.",
  serviceCareTitle: "Nâng cấp lên YONGYUAN Care",
  serviceCareDamageTitle: "Bảo vệ hư hỏng do tai nạn",
  serviceCareDamageDesc: "Kế hoạch bảo vệ toàn diện hơn để giảm thiệt hại do sự cố bất ngờ.",
  serviceCareExchangeTitle: "Dịch vụ đổi nhanh",
  serviceCareExchangeDesc: "Sắp xếp đổi nhanh ưu tiên trong điều kiện đủ điều kiện để đẩy nhanh thu hồi vốn.",
  viewProduct: "Xem sản phẩm",
  learnMore: "Tìm hiểu thêm",
  catUv: "Máy in UV phẳng",
  catCylinder: "Máy in hình trụ",
  catCrystal: "Máy in nhãn pha lê",
  catDtf: "Máy in DTF",
  catDtg: "Máy in DTG",
  companyName: "Shenzhen Yongyuan Technology Co., Ltd.",
  phone: "Điện thoại: 17748697567 Quản lý Tang",
  email: "Email: sales@yongyuanprinter.com",
  copyright: "Copyright © 2012-2026 Shenzhen Yongyuan Technology Co., Ltd. Bảo lưu mọi quyền",
  productsHeroTitle: "Sản phẩm",
  productsHeroDesc: "Dòng đầy đủ thiết bị UV phẳng, hình trụ, nhãn pha lê, DTF và DTG cho nhu cầu công suất và ứng dụng đa dạng.",
  productsBreadcrumbHome: "Trang chủ",
  productsBreadcrumbCenter: "Sản phẩm",
  productsEmpty: "Sản phẩm trong danh mục này sắp ra mắt.",
  productsQuoteTitle: "Yêu cầu giải pháp và báo giá",
  productsQuoteDesc: "Chia sẻ kịch bản ứng dụng và yêu cầu công suất của bạn, chúng tôi sẽ đề xuất giải pháp thiết bị phù hợp.",
  productsContact: "Liên hệ",
  aboutHeroTitle: "Về Yongyuan",
  aboutHeroDesc: "23 năm tập trung vào R&D và sản xuất thiết bị in UV",
  productA23Subtitle: "Máy in UV thông minh 6 màu để bàn",
  productA23Feature1: "Định dạng in A4",
  productA23Feature2: "Hệ thống cung cấp mực thông minh",
  productA23Feature3: "Phát hiện chiều cao tự động bằng hồng ngoại",
  productA35Subtitle: "Máy in UV thông minh 6 màu để bàn",
  productA35Feature1: "Định dạng in A3+",
  productA35Feature2: "Hệ thống cung cấp mực thông minh",
  productA35Feature3: "Phát hiện chiều cao tự động bằng hồng ngoại",
  productA43Subtitle: "Máy in UV thông minh 8 màu hàng đầu",
  productA43Feature1: "Định dạng in A3",
  productA43Feature2: "Nhiều cấu hình đầu in",
  productA43Feature3: "Hệ thống cung cấp mực thông minh",
  productA46Subtitle: "Máy in UV thông minh 8 màu hàng đầu",
  productA46Feature1: "Định dạng in A2",
  productA46Feature2: "Nhiều cấu hình đầu in",
  productA46Feature3: "Hệ thống cung cấp mực thông minh",
  productA57Subtitle: "Máy in UV thông minh 8 màu hàng đầu",
  productA57Feature1: "Định dạng in A2+",
  productA57Feature2: "Nhiều cấu hình đầu in",
  productA57Feature3: "Hệ thống cung cấp mực thông minh",
  productA69Subtitle: "Máy in UV thông minh 8 màu hàng đầu",
  productA69Feature1: "Định dạng in A1",
  productA69Feature2: "Nhiều cấu hình đầu in",
  productA69Feature3: "Hệ thống cung cấp mực thông minh",
  productA1216Subtitle: "Máy in UV phẳng định dạng lớn hàng đầu",
  productA1216Feature1: "Định dạng in 1200×1600cm",
  productA1216Feature2: "Nhiều cấu hình đầu in",
  productA1216Feature3: "Hệ thống định vị thị giác",
  productA2513Subtitle: "Máy in UV phẳng định dạng lớn hàng đầu",
  productA2513Feature1: "Định dạng in 2500×1300cm",
  productA2513Feature2: "Nhiều cấu hình đầu in",
  productA2513Feature3: "Hệ thống định vị thị giác",
  productCylinderElfSubtitle: "Máy in hình trụ tốc độ cao 360°",
  productCylinderElfFeature1: "In 360°",
  productCylinderElfFeature2: "Tùy chỉnh cốc và chai",
  productCylinderElfFeature3: "Thay đổi đồ gá nhanh",
  productCupPlusSubtitle: "Giải pháp in cốc và chai đa kích thước",
  productCupPlusFeature1: "Đồ gá đa kích thước",
  productCupPlusFeature2: "Hiệu suất sản xuất cao",
  productCupPlusFeature3: "Đầu ra ổn định",
  productCrystal60Subtitle: "Hệ thống in và dập nóng nhãn pha lê tất cả trong một",
  productCrystal60Feature1: "Bề rộng 60cm",
  productCrystal60Feature2: "Tích hợp in và dập nóng",
  productCrystal60Feature3: "Hệ thống cuốn hiệu quả",
  productCrystalC60UltraFeature1: "Khổ rộng 60 cm",
  productCrystalC60UltraFeature2: "Vàng/bạc/nhãn silicone 3D đa phương án",
  productCrystalC60UltraFeature3: "Sản xuất hàng loạt",
  productCrystal30Subtitle: "Máy in nhãn pha lê nhỏ gọn độ chính xác cao",
  productCrystal30Feature1: "In chính xác nhỏ gọn",
  productCrystal30Feature2: "Dễ vận hành",
  productCrystal30Feature3: "Tùy chỉnh cá nhân",
  productDtf60Subtitle: "Máy in chuyển nhiệt DTF mực trắng",
  productDtf60Feature1: "Chuyển nhiệt DTF mực trắng",
  productDtf60Feature2: "Lớp màu phong phú",
  productDtf60Feature3: "Phụ kiện may mặc",
  productDtfF20Subtitle: "Máy in DTF mực trắng để bàn nhỏ nhất trong ngành",
  productDtfF20Feature1: "Khổ A4",
  productDtfF20Feature2: "Tùy chỉnh số lượng nhỏ",
  productDtfF20Feature3: "Hệ thống mực thông minh",
  productDtfF30Subtitle: "Máy in DTF mực trắng để bàn",
  productDtfF30Feature1: "Khổ A3",
  productDtfF30Feature2: "Đầu đơn thủ công/tự động tùy chọn",
  productDtfF30Feature3: "Hệ thống mực thông minh",
  productDtfF30ProSubtitle: "Máy in DTF mực trắng",
  productDtfF30ProFeature1: "Khổ A3",
  productDtfF30ProFeature2: "Hai đầu với cuốn phim tự động",
  productDtfF30ProFeature3: "Hệ thống mực thông minh",
  productDtfF33Subtitle: "Máy in DTF mực trắng",
  productDtfF33Feature1: "Khổ A3",
  productDtfF33Feature2: "Đầu đơn thủ công/tự động tùy chọn",
  productDtfF33Feature3: "Hệ thống mực thông minh",
  productDtfF70ProSubtitle: "Máy in DTF mực trắng khổ rộng 70 cm",
  productDtfF70ProFeature1: "Khổ A2",
  productDtfF70ProFeature2: "Tùy chọn 2–4 đầu in",
  productDtfF70ProFeature3: "Hệ thống nạp và xuất liệu tự động",
  productDtfF70ProFeature4: "Chế độ in tiếp tục thông minh",
  productDtf30Subtitle: "Máy in DTF mực trắng nhỏ gọn",
  productDtf30Feature1: "Tùy chỉnh số lượng nhỏ",
  productDtf30Feature2: "Tái tạo màu chính xác",
  productDtf30Feature3: "Dễ sử dụng",
  productDtgPrintSubtitle: "Máy in kỹ thuật số in trực tiếp lên vải",
  productDtgPrintFeature1: "In trực tiếp đa vật liệu",
  productDtgPrintFeature2: "Năng suất cao",
  productDtgPrintFeature3: "Ổn định và bền bỉ",
  productDtg3250DSubtitle: "Mẫu DTF & DTG 2-in-1 duy nhất trong ngành",
  productDtg3250DFeature1: "Khổ A3+",
  productDtg3250DFeature2: "In kép công nghệ DTF & DTG",
  productDtg3250DFeature3: "Hệ thống mực thông minh",
  productDtg3646TSubtitle: "Máy in DTG hai trạm",
  productDtg3646TFeature1: "Chế độ sản xuất liên tục",
  productDtg3646TFeature2: "Tăng 100% hiệu suất sản xuất",
  productDtg3646TFeature3: "Hệ thống mực thông minh",
  productDtgMaxSubtitle: "Máy in DTG kỹ thuật số công nghiệp",
  productDtgMaxFeature1: "Công suất công nghiệp",
  productDtgMaxFeature2: "Ổn định và bền bỉ",
  productDtgMaxFeature3: "Vận hành liên tục",
  app01Title: "Ốp điện thoại",
  app02Title: "Bóng golf",
  app03Title: "Bảng đá",
  app04Title: "Bút bi",
  app05Title: "Hộp đựng kính",
  app06Title: "In khắc gỗ",
  app07Title: "Lon đồ uống",
  app08Title: "Bàn phím",
  app09Title: "Bình giữ nhiệt",
  app10Title: "Hành lý",
  app11Title: "Sản phẩm acrylic",
  app12Title: "Sổ tay",
  app13Title: "Huy hiệu",
  app14Title: "Ví đựng thẻ da",
  app15Title: "Thẻ nhận dạng",
  app16Title: "Nghệ thuật trên kính",
  appDtgCase01: "Áo thun",
  appDtgCase02: "Áo hoodie",
  regionCn: "Trung Quốc",
  regionUs: "Hoa Kỳ",
  regionGb: "Vương quốc Anh",
  regionDe: "Đức",
  regionAe: "UAE",
  regionIn: "Ấn Độ",
  regionJp: "Nhật Bản",
  regionVn: "Việt Nam",
  regionBr: "Brazil",
  regionAu: "Úc",

  // synced from en
    uiClose: "Close",
    carouselPrev: "Previous product",
    carouselNext: "Next product",
    heroSlidePrev: "Previous slide",
    heroSlideNext: "Next slide",
    heroSlideDot: "Go to slide {n}",
    customerStoriesTrustedTitle: "Trusted Worldwide",
    customerStoriesBadge: "{count} international customer photos showcased",
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germany",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spain",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Saudi Arabia",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "South Korea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Netherlands",
    customerStoryCountrySweden: "Sweden",
    customerStoryCountrySouthAfrica: "South Africa",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "United States",
    customerStoryCaption01: "USA�?090 UV Printer",
    customerStoryCaption02: "Germany｜F33 DTF Printer",
    customerStoryCaption03: "Thailand�?250 UV Printer",
    customerStoryCaption04: "Spain�?250 UV Printer",
    customerStoryCaption05: "Brazil�?030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Saudi Arabia�?030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "South Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan�?030 UV Printer",
    customerStoryCaption12: "Mexico�?060 UV Printer",
    customerStoryCaption13: "Argentina�?060 UV Printer",
    customerStoryCaption14: "Philippines�?090 UV Printer",
    customerStoryCaption15: "Indonesia�?030 UV Printer",
    customerStoryCaption16: "Netherlands�?030 UV Printer",
    customerStoryCaption17: "Sweden�?060 UV Printer",
    customerStoryCaption18: "Germany�?030 UV Printer",
    customerStoryCaption19: "South Africa�?030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "USA｜F70Pro DTF Printer",
    customerStoryCaption23: "USA�?513 UV Printer",
    customerStoryCaption24: "USA�?090 UV Printer",
    customerStoryCaption25: "USA�?030 UV Printer",
    customerStoryCaption26: "USA�?250 UV Printer",
    customerStoryCaption27: "South Korea�?060 UV Printer",
    customerStoryCaption28: "Netherlands�?060 UV Printer",
    catUvNav: "UV Flatbed",
    catCylinderNav: "Cylindrical",
    catCrystalNav: "Crystal Label",
    catDtfNav: "DTF",
    catDtgNav: "DTG",
    productA3220Subtitle: "Ultra Wide-Format Industrial UV Flatbed Solution",
    productA3220Feature1: "320×200cm Print Format",
    productA3220Feature2: "Visual Positioning System",
    productA3220Feature3: "Continuous Batch Production",
    productCrystal60UltraSubtitle: "Flagship Crystal Label Printing Solution",
    cityShanghai: "Shanghai",
    cityShenzhen: "Shenzhen",
    cityDetroit: "Detroit",
    cityManchester: "Manchester",
    cityStuttgart: "Stuttgart",
    cityDubai: "Dubai",
    cityPune: "Pune",
    cityOsaka: "Osaka",
    cityHoChiMinh: "Ho Chi Minh City",
    citySaoPaulo: "São Paulo",
    cityMelbourne: "Melbourne",
};
